module.exports = __webpack_public_path__ + "img/gobCon.c78756e8.png";